import {
  convertMetricsNameToV3,
  getDashboardMetricsV3
} from 'common/services/metrics.service';
import { DEFAULT_REQUESTED_TEAM_METRICS } from '../dashboard.consts';
import { createTrendDataV3 } from '../dashboard.service';

export const loadOrgTrendData = async (
  current5Iterations,
  metricsCalculationConfig,
  organization
) => {
  const time_ranges = current5Iterations.map(
    ({ start_date: after, end_date: before }) => ({ before, after })
  );

  const { metricsCalculationStrategy } = metricsCalculationConfig;

  const v3Metrics = DEFAULT_REQUESTED_TEAM_METRICS;

  const data = await getDashboardMetricsV3({
    time_ranges,
    requested_metrics: convertMetricsNameToV3(
      v3Metrics,
      metricsCalculationStrategy
    )
  });

  return createTrendDataV3(data, current5Iterations);
};
